import { useEffect } from "react";
import PropTypes from "prop-types";
import Image from "../../image/image";
import { imagePrefix } from "../../../../utils/helperServices";
import styles from "./OutcomeInformation.module.scss";
import labels from "../../../../config/labels";
import * as Analytics from "../../../../services/analyticsUtag";

const OutcomeInformation = ({
  className,
  title,
  screenType,
  iconType,
  description,
  customerStatus,
  setDisableBackButton,
  handleHeading,
}) => {
  useEffect(() => {
    handleHeading("hide", "desc");
    setDisableBackButton(true);
    window.scrollTo(0, 0);
    switch (screenType) {
      case labels.creditVetting.approved.lbl_screentype:
        Analytics.view({
          page_event: "view",
          page_name: `checkout: credit check: ${customerStatus}: success`,
          ...Analytics.getUtagData([
            "page_channel",
            "page_master_tab",
            "visitor_login_status",
            "visitor_customer_id",
            "visitor_id_hash",
            "visitor_msisdn_hash",
            "visitor_subscription_type",
          ]),
        });
        break;
    }
  }, []);

  return (
    <div className={`${styles["main-container"]} ${className}`}>
      <div className={styles["icon"]}>
        {screenType === labels.creditVetting.lbl_screentype_loading ? (
          <Image img_path={`${imagePrefix}/assets/images/lock-loading.gif`} />
        ) : (
          <Image img_path={iconType} />
        )}
      </div>
      <div className={styles["title"]}> {title} </div>
      {description && <div className={styles["desc"]}> {description} </div>}
    </div>
  );
};

OutcomeInformation.propTypes = {
  screentype: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
};

export default OutcomeInformation;
